import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import DialogModal from '../../utils/DialogModal';


export interface LiveExitDialogProps {
  open: boolean;
  onClose: (value?: string) => void;
}

const LiveExitDialog = (props: LiveExitDialogProps) => {

  const liveStreamRunning = useSelector((state: any) => state.layout.liveStreamRunning);

  const { open, onClose, ...other } = props;

  return (
    <DialogModal open={open} onClose={onClose} iconClass={"clapper"} buttonCancel={"CANCEL"} buttonOk={"YES, END STREAM"}>
      <p>That’s a wrap! Are you sure you want to end your stream?</p>
    </DialogModal>
  )
}

export default LiveExitDialog;

